import { Container } from "@mui/material";
import Dummy from "components/Dummy";
import P from "components/P";
import CustomButton from "components/buttons/CustomButton";
import FlexChild from "layouts/flex/FlexChild";
import VerticalFlex from "layouts/flex/VerticalFlex";
import { useLocation, useNavigate } from "react-router-dom";
import puffuIcon from "resources/img/puffu/puffuIcon.png";

function MobileSignUpComplete() {
    const location = useLocation();
    const navigate = useNavigate();
    const onClick = () => {
        navigate(`/ws/${location.state.storeCode}/mobile`);
    }
    const btnStyle = {
        width: "90%",
        backgroundColor: "var(--main-color)",
        border: "none",
        height: "48px"
    }

    return (
        <Container height={"85vh"}>
            <VerticalFlex>
                <FlexChild justifyContent={"flex-end"}>
                    <Dummy height={"50px"} />
                    <img src={puffuIcon} />
                    <Dummy height={"15px"} />
                    <P size={"7vw"} font={"GmarketSansBold"} color={"var(--main-color)"}>회원가입완료!</P>
                    <Dummy height={"15px"} />
                    <P size={18} weight={"bold"}>회원가입이 완료되었습니다.</P>
                </FlexChild>
                
                {/* <FlexChild justifyContent={"flex-end"}>
                    <CustomButton style={btnStyle} onClick={onClick} text={"첫 화면으로 돌아가기"} />
                </FlexChild> */}
                <FlexChild justifyContent={"flex-end"}>
                    <CustomButton style={btnStyle} onClick={onClick} text={"돌아가기"} />
                </FlexChild>

            </VerticalFlex>
        </Container>
    );
}

export default MobileSignUpComplete;